import axios from 'axios';
import store from '../../store';

const model = () => {
	return {
		id: 		null,
		client_id: 	'',
		payload: 	'',
		topic: 		''
	};
};

const save = async (model) => {
	return model;
};

const read = async(id) => {
	return (await axios.get(`/activities/${id}`)).data;
};

const window = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'activity-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const open = async (id, onSave) => {
	window(id ? await read(id) : model(), async (model) => {
		const r = await save(model);

		if (r) {
			if (onSave) onSave(r);
			return true;
		}

		return false;
	});
};

const del = async (id) => {
	await axios.delete(`/activities/${id}`);
};

export default {
	model,
	save,
	read,
	open,
	window,
	del
};